(function(){
"use strict";
/* Permuta nella scheda prodotto.
   La pratica NON nasce qui: il popup chiede solo la stima. Sara' il
   gestionale a creare l'acquisto quando arriva l'ordine. */

var CHIAVE="dema_permuta";
var GIORNI=14;

function euro(n){return "\u20ac"+Number(n).toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}
function prezzoPieno(){
 var t=document.getElementById("tag");
 if(!t)return 0;
 var s=(t.textContent||"").replace(/[^\d,]/g,"").replace(",",".");
 return parseFloat(s)||0;
}
function leggi(){try{return JSON.parse(sessionStorage.getItem(CHIAVE)||"null")}catch(e){return null}}
function salva(p){try{sessionStorage.setItem(CHIAVE,JSON.stringify(p))}catch(e){}}
function dimentica(){try{sessionStorage.removeItem(CHIAVE)}catch(e){}attributi(null);disegna()}

function attributi(p){
 var a;
 if(p){
  a={
   "Permuta": p.modello + (p.capacita ? " " + p.capacita : ""),
   "Permuta valutazione": euro(p.valore),
   "Permuta stato": "Usato da ricevere entro " + GIORNI + " giorni \u00b7 rimborso dopo verifica"
  };
  try{ a["_permuta_dati"]=JSON.stringify(p.dati||{}); }catch(e){}
 }else{
  a={"Permuta":"","Permuta valutazione":"","Permuta stato":"","_permuta_dati":""};
 }
 try{
  fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({attributes:a})});
 }catch(e){}
}

function disegna(){
 var p=leggi();
 var btn=document.getElementById("demaTradeBtn");
 var box=document.getElementById("demaTradeBox");
 if(!p){ if(box)box.remove(); if(btn)btn.hidden=false; return; }
 if(btn)btn.hidden=true;
 var pieno=prezzoPieno();
 var reale=Math.max(0,pieno-Number(p.valore||0));
 if(!box){
  box=document.createElement("div");
  box.id="demaTradeBox";
  var anc=document.getElementById("demaTotal")||document.getElementById("demaAdd");
  if(anc&&anc.parentNode)anc.parentNode.insertBefore(box,anc); else return;
 }
 box.innerHTML=
  '<div class="th"><span class="tk"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M4 12.5l4.5 4.5L20 6"/></svg></span>'+
  '<b>Permuta aggiunta</b></div>'+
  '<div class="tm">Il tuo '+p.modello+(p.capacita?" "+p.capacita:"")+' \u00e8 stato valutato <b>'+euro(p.valore)+'</b></div>'+
  '<div class="calc"><span class="v">'+euro(reale)+'</span>'+
  '<span class="d">quanto ti costa davvero questo iPhone</span></div>'+
  '<div class="note">Al checkout paghi '+euro(pieno)+'. Ricevi subito il tuo ordine, '+
  'poi ci mandi il tuo '+p.modello+' entro '+GIORNI+' giorni con l\'etichetta prepagata: '+
  'ti versiamo '+euro(p.valore)+' entro 48 ore dalla verifica.</div>'+
  '<button type="button" class="rm" id="demaTradeRm">Rimuovi la permuta</button>';
 var rm=document.getElementById("demaTradeRm");
 if(rm)rm.addEventListener("click",dimentica);
}

function chiudi(){
 var m=document.getElementById("mTrade");
 if(m)m.classList.remove("on");
 document.body.style.overflow="";
}

addEventListener("message",function(ev){
 if(String(ev.origin).indexOf("vendi.dematechnology.com")===-1)return;
 var d=ev.data;
 if(!d||typeof d!=="object")return;

 /* L'altezza comunicata dal modulo NON si usa piu': facendo crescere
    il riquadro quanto il contenuto, la barra dell'offerta — che e'
    ancorata in fondo alla finestra — finiva in fondo a un riquadro
    lunghissimo e restava irraggiungibile. Il riquadro sta dentro il
    popup e scorre al proprio interno, cosi' la barra resta in vista. */
 if(d.tipo==="permuta-altezza")return;

 if(d.tipo==="permuta-accettata"){
  var p={modello:d.modello||"iPhone",capacita:d.capacita||"",valore:Number(d.valore)||0,dati:d.dati||{}};
  salva(p);attributi(p);disegna();
  chiudi();
  var b=document.getElementById("demaTradeBox");
  if(b)b.scrollIntoView({behavior:"smooth",block:"center"});
 }
 if(d.tipo==="permuta-chiudi")chiudi();
});

/* Le sezioni sotto la scheda creano un proprio livello: da dentro il
   blocco acquisto il popup non riesce a scavalcarle. Lo spostiamo in
   fondo alla pagina, fuori da qualsiasi contenitore. */
function liberaPopup(){
 var m=document.getElementById("mTrade");
 if(m&&m.parentNode!==document.body)document.body.appendChild(m);
}

function indirizzo(){
 var titolo=((document.querySelector(".dema-buy h1")||{}).textContent||"").trim();
 return "https://vendi.dematechnology.com/?incorporato=1"+
  "&origine="+encodeURIComponent("scheda "+titolo)+
  "&prodotto="+encodeURIComponent(titolo)+
  "&t="+Date.now();
}
function apri(){
 var m=document.getElementById("mTrade");
 if(!m)return;
 liberaPopup();
 var fr=document.getElementById("demaTradeFrame");
 if(fr){fr.style.height="";fr.setAttribute("src",indirizzo());}
 m.classList.add("on");
 document.body.style.overflow="hidden";
}

function avvia(){
 liberaPopup();
 var b=document.getElementById("demaTradeBtn");
 if(b)b.addEventListener("click",apri);
 disegna();
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",avvia);
else avvia();

var ultimo=-1;
setInterval(function(){
 var p=leggi(); if(!p)return;
 var q=prezzoPieno();
 if(q!==ultimo){ultimo=q;disegna()}
},900);
})();
